<template>
  <div>
    <!--
    <el-row>
      <el-col :span=3>
        <el-input v-model="problemGuid" placeholder="输入大题号"></el-input>
      </el-col>
      <el-col :span=3>
        <el-button type="primary" @click="searchProblem">查找</el-button>
      </el-col>
    </el-row>-->
    <el-row>
      <el-table
      :data="tableData"
      stripe
      :height="tabH">
        <el-table-column
          v-for="col in cols"
          :key="col.prop"
          :prop="col.prop"
          :label="col.label"
          :width="col.width"
          show-overflow-tooltip>
        </el-table-column>
        <el-table-column
          key="edit"
          label="修改"
          width="80">
          <template v-if="col.prop == 'edit'" scope="scope">
            <el-button size="small" @click="edit(scope.row.guid)"><i class="el-icon-edit"></i></el-button>
          </template>
        </el-table-column>
        <el-table-column
          key="edit"
          label="解题过程"
          width="100">
          <template v-if="col.prop == 'edit'" scope="scope">
            <el-button size="small" @click="gotoSolutionList(scope.row.guid)"><i class="el-icon-edit"></i></el-button>
          </template>
        </el-table-column>
        <el-table-column
          key="edit"
          label="相关知识"
          width="100">
          <template v-if="col.prop == 'edit'" scope="scope">
            <el-button size="small" @click="gotoKnowledgeList(scope.row.guid)"><i class="el-icon-edit"></i></el-button>
          </template>
        </el-table-column>
        <el-table-column
          key="edit"
          label="解题提示"
          width="100">
          <template v-if="col.prop == 'edit'" scope="scope">
            <el-button size="small" @click="gotoHintList(scope.row.guid)"><i class="el-icon-edit"></i></el-button>
          </template>
        </el-table-column>
        <el-table-column
          key="edit"
          label="删除题目"
          width="100">
          <template v-if="col.prop == 'edit'" scope="scope">
            <el-button size="small" @click="deleteProblem(scope.row.guid)"><i class="el-icon-delete"></i></el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
  </div>
</template>

<script>
  import examineProblemDlg from '@/components/examineProblemDlg'
  import solutionTableFatherDlg from '@/components/solutionTableFatherDlg'
  import knowledgeTableFatherDlg from '@/components/knowledgeTableFatherDlg'
  import hintTableFatherDlg from '@/components/hintTableFatherDlg'

  export default {
    data () {
      return {
        problemGuid: 1,
        cols: [
          {
            prop: 'guid',
            label: 'guid',
            width: 150
          },
          {
            prop: 'main',
            label: '主题号',
            width: 80
          },
          {
            prop: 'minor',
            label: '子题号',
            width: 80
          },
          {
            prop: 'type1',
            label: '类别1',
            width: 100
          },
          {
            prop: 'type2',
            label: '类别2',
            width: 100
          },
          {
            prop: 'title',
            label: '标题',
            width: 120
          },
          {
            prop: 'keyword',
            label: '关键词',
            width: 120
          },
          {
            prop: 'amark',
            label: '答案标记',
            width: 120
          },
          {
            prop: 'aformat',
            label: '答案格式',
            width: 120
          },
          {
            prop: 'answer',
            label: '答案',
            width: 120
          }
        ]
      }
    },
    props: ['tableData'],
    computed: {
      tabH () {
        return this.winH - (this.search ? this.search.getHeight() : 80) - 88
      }
    },
    methods: {
      edit (guid) {
        console.log('examineProblemDlg->edit id = ', guid)
        examineProblemDlg({
          isEditData: true,
          guid: guid
        })
      },
      gotoSolutionList (guid) {
        console.log('solutionTableFatherDlg->edit id = ', guid)
        solutionTableFatherDlg({
          type: 0,
          tmguid: guid
        })
      },
      gotoKnowledgeList (guid) {
        console.log('knowledgeTableFatherDlg->edit id = ', guid)
        knowledgeTableFatherDlg({
          type: 0,
          tmguid: guid
        })
      },
      gotoHintList (guid) {
        console.log('hintTableFatherDlg->edit id = ', guid)
        hintTableFatherDlg({
          type: 0,
          tmguid: guid
        })
      },
      searchProblem () {
        // 查找题目

      },
      deleteProblem (guid) {
        // 删除，不做入
      }
    }
  }
</script>

<style>
  .h20{
    height: 20px;
  }
</style>



// WEBPACK FOOTER //
// problemTable.vue?1a07ddae